import { render, staticRenderFns } from "./OrdersTopSearch.vue?vue&type=template&id=20b05904&"
import script from "./OrdersTopSearch.js?vue&type=script&lang=js&"
export * from "./OrdersTopSearch.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports